import { render } from "./Records.vue?vue&type=template&id=b88bc1ae&scoped=true"
import script from "./Records.vue?vue&type=script&lang=js"
export * from "./Records.vue?vue&type=script&lang=js"

import "./Records.vue?vue&type=style&index=0&id=b88bc1ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88bc1ae"]])

export default __exports__